module.exports = __webpack_public_path__ + "static/media/apartmentLink.10087c28.svg";